export namespace PodMallUserEntity {
  export class User {
    deliveryRecipientName: string
    id: number
    type: 'MATHFLAT_TEACHER'
    deliveryAddress: string
    deliveryRecipientEmail: string
    deliveryRecipientPhoneNumber: string
    deliveryAddressDetail: string
    academyId: string
    deliveryZipCode: string
    deliveryMemo: string
    freeTrialOrderQuantityLimit: number
    totalOrderQuantity: number
    productDiscountEventName: string
    productDiscountRate: number
    point: number

    constructor(props: User) {
      this.id = props.id
      this.deliveryRecipientName = props.deliveryRecipientName
      this.type = props.type
      this.deliveryAddress = props.deliveryAddress
      this.deliveryRecipientEmail = props.deliveryRecipientEmail
      this.deliveryRecipientPhoneNumber = props.deliveryRecipientPhoneNumber
      this.deliveryAddressDetail = props.deliveryAddressDetail
      this.academyId = props.academyId
      this.deliveryZipCode = props.deliveryZipCode
      this.deliveryMemo = props.deliveryMemo
      this.freeTrialOrderQuantityLimit = props.freeTrialOrderQuantityLimit
      this.totalOrderQuantity = props.totalOrderQuantity
      this.productDiscountEventName = props.productDiscountEventName
      this.productDiscountRate = props.productDiscountRate
      this.point = props.point
    }
  }
}
